import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

export const StContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;

  padding: ${({ theme }) => theme.UI.SpacingPx.Space6};
  padding-bottom: calc(
    ${({ theme }) => theme.UI.Spacing.Space6 * 2}px +
      max(var(--safe-area-inset-bottom), 20px)
  );

  @media ${breakpoints.fromM} {
    justify-content: center;
    align-items: center;
  }
`

export const StContent = styled.div`
  margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space12};

  @media ${breakpoints.fromM} {
    max-width: 600px;
    margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space12};
  }
`

export const StDesktopButtonContainer = styled.div`
  width: 100%;
  max-width: 600px;
`

export const StButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.UI.SpacingPx.Space3};
  padding-bottom: calc(
    ${({ theme }) => theme.UI.SpacingPx.Space3} +
      max(var(--safe-area-inset-bottom), 20px)
  );

  background-color: ${({ theme }) => theme.Colors.Background.White};
  box-shadow: 0px -1px 20px 0px rgba(4, 24, 49, 0.07);

  button {
    width: 100%;
    max-width: 343px;
  }
`
